import React from 'react';

interface Icon3DBackendTrainingProps {
  size?: string;
}

const Icon3DBackendTraining: React.FC<Icon3DBackendTrainingProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'backend-flow 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 8px rgba(59, 130, 246, 0.3))' }}>
          <defs>
            <linearGradient id="backendGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3b82f6" />
              <stop offset="50%" stopColor="#60a5fa" />
              <stop offset="100%" stopColor="#1e40af" />
            </linearGradient>
          </defs>
          <circle cx="12" cy="8" r="3" fill="url(#backendGradient)" opacity="0.4" stroke="url(#backendGradient)" strokeWidth="1" />
          <circle cx="12" cy="8" r="2" fill="url(#backendGradient)" />
          <path d="M8 14c-1.5 0-2 1-2 2v3h12v-3c0-1-0.5-2-2-2" fill="url(#backendGradient)" opacity="0.3" stroke="url(#backendGradient)" strokeWidth="1" />
          <circle cx="4" cy="16" r="1" fill="url(#backendGradient)" opacity="0.5" />
          <circle cx="20" cy="16" r="1" fill="url(#backendGradient)" opacity="0.5" />
        </svg>
        <style>{`
          @keyframes backend-flow {
            0%, 100% { transform: rotateZ(0deg) rotateY(0deg); }
            50% { transform: rotateZ(10deg) rotateY(15deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DBackendTraining;
